/* ++++++++++ --------------- TABLE HEADER : STYLES --------------- ++++++++++ */
import {pxToEm} from "@insticator/insticator-ui";

export default {
    tableHeader : {
        display: 'flex',
        height: '62px',
        padding: '0px 32px',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignSelf: 'stretch',
        borderBottom: '1px solid #E7ECF7',
        background: 'none',
        '& > .header': {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            '& > .title': {
                flex : 1,
                alignSelf: 'center',
                color: '#061240',
                'font-variant-numeric': 'lining-nums proportional-nums',
                fontFamily: "Work Sans",
                fontSize: pxToEm(16),
                fontStyle : 'normal',
                fontWeight: 700,
                lineHeight: pxToEm(22),

            },
            '& button': {
                height: '2.5em',
            }

        }
    }
};